import { render, staticRenderFns } from "./gen-cover.vue?vue&type=template&id=09fe32cf&scoped=true"
import script from "./gen-cover.vue?vue&type=script&lang=js"
export * from "./gen-cover.vue?vue&type=script&lang=js"
import style0 from "./gen-cover.vue?vue&type=style&index=0&id=09fe32cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe32cf",
  null
  
)

export default component.exports